<template>
	<div class="form-block" :class="generalClasses">
		<div v-if="showHeader"
			class="form-block__header"
			:class="{
				'form-block__header--not-visible': !isBlockVisible,
				'form-block__header--column': !!button
			}">
			<h3 v-if="title || $slots.title" :class="titleClasses">
				<div v-if="tip" :class="tipClasses">
					<UiTip
						:position="tip.position"
						:message="tip.message"
						:tip-styles="tip.styles"
					/>
				</div>
				<slot name="title">
					<p v-html="title"/>
					<span v-if="titleCounter" class="form-block__counter">({{ titleCounter }})</span>
				</slot>
			</h3>
			<UiButton 
				v-if="showVisibilityToggle"
				size="xs"
				type="link"
				:label="isBlockVisible ? 'Свернуть' : 'Показать'"
				:append-icon="isBlockVisible ? 'drop-up' : 'drop-down'"
				@click="toggleVisibility"
			/>
			<UiButton
				v-if="button"
				:label="getFieldPropertyFn(button, 'label')"
				:disabled="getFieldPropertyFn(button, 'readonly')"
				:pending="getFieldPropertyFn(button, 'pending')"
				:size="getFieldPropertyFn(button, 'size')"
				:type="getFieldPropertyFn(button, 'btnType')"
				:block="getFieldPropertyFn(button, 'block' , mobile)"
				@click="() => onClick(button)"
			/>
		</div>
		<div>
			<slot name="additionalSlot"/>
		</div>
		<div 
			ref="toggleHeightTarget"
			v-toggle-height
			class="form-block__content"
		>
			<slot/>
		</div>
	</div>
</template>

<script>
import toggleHeight from '@/directives/toggleHeight';
import {randomKey} from "@utils/common";

export default {
	name: "UiBlock",
	directives: {
		toggleHeight,
	},
	props: {
		title: {
			type: String,
			default: undefined,
		},
		titleCounter: {
			type: Number,
			default: undefined,
		},
		tip: {
			type: Object,
			default: null,
		},
		/**
		 * Признак показа кнопки скрытия содержимого блока
		 */
		showVisibilityToggle: {
			type: Boolean,
			default: false,
		},
		storageVisibilityKey: {
			type: String,
			default: null,
		},
		/**
		 * Признак видимости блока
		 */
		visible: {
			type: Boolean,
			default: undefined,
		},
		/**
		 * Признак видимости блока
		 */
		withoutVisibleAnimation: {
			type: Boolean,
			default: false,
		},
		/**
		 * Включение мобильной версии
		 */
		mobile: {
			type: Boolean,
			default: false,
		},
		/**
		 * Дополнительная кнопка
		 */
		button: {
			type: Object,
		},
		/**
		 * Отключить сохранение положения
		 */
		disableVisibleStorage: {
			type: Boolean,
			default: false,
		},
	},
	data: () => ({
		isBlockVisible: true
	}),
	computed: {
		generalClasses() {
			return {
				'b26': !this.mobile,
				'form-block__mobile': this.mobile
			}
		},
		titleClasses() {
			return {
				'form-block__title': true,
				'flex-grow': true,
				'flex': this.title
			}
		},
		tipClasses() {
			return {
				'form-block__tip': true,
				'blocked': this.title,
				'form__tip': true,
			}
		},
		showHeader() {
			return this.title || this.$slots.title || this.showVisibilityToggle;
		},
	},
	watch: {
		async visible() {
			if (!this.$refs.toggleHeightTarget) {
				await this.$nextTick();
			}

			this.isBlockVisible = this.getLocalStorageVisibility();

			this.$refs.toggleHeightTarget?.toggleHeight(this.isBlockVisible);
		},
	},
	async mounted() {
		if (!this.$refs.toggleHeightTarget) {
			await this.$nextTick();
		}

		this.isBlockVisible = this.getLocalStorageVisibility();

		this.$refs.toggleHeightTarget?.toggleHeight(this.isBlockVisible);
	},
	methods: {
		getFieldPropertyFn(field, prop, def = undefined) {
			let propVal = field ? field[prop] : undefined;
			if (propVal) {
				if (typeof propVal === "function") {
					propVal = propVal();
				}
			}
			return propVal != undefined ? propVal : def;
		},
		onClick(field) {
			if (field.clickHandler && (typeof field.clickHandler === "function")) {
				field.clickHandler(field);
			}
		},
		toggleVisibility() {
			this.isBlockVisible = !this.isBlockVisible;
			this.$refs.toggleHeightTarget.toggleHeight(this.isBlockVisible);
			this.setLocalStorageVisibility(this.isBlockVisible);
		},
		getLocalStorageKey() {
			const key = this.storageVisibilityKey || this.title || randomKey();
			return `isBlockVisible::${this.$kc.username()}${key}`;
		},
		getLocalStorageVisibility() {
			if (this.visible !== undefined && !this.visible) {
				return false;
			}
			if (!this.showVisibilityToggle) {
				return true;
			}

			if (this.disableVisibleStorage) {
				if (this.visible !== undefined) {
					return this.visible;
				}
				return true;
			}

			const ls = localStorage.getItem(this.getLocalStorageKey());

			if (ls === null || ls === undefined || ls === 'undefined') {
				return true;
			}

			return JSON.parse(ls);
		},
		setLocalStorageVisibility(value) {
			localStorage.setItem(this.getLocalStorageKey(), value);
		},
	}
}
</script>
